import React from "react";
import invariant from "invariant";
import { ToastContext } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";


// A connector for APIMiddleware. It decorates the fetch, and observes the return
// to PUSH errors when the status is not expected. Expected status are by default
// all >= 500 and 403 errors.
export function useWithErrorStack(fetch) {
	const { error } = React.useContext(ToastContext);
	const { t } = useTranslation('', { useSuspense: false });

	return (fetch) => {
		return async (url, options={}) => {
			const expected = (options && options.expected) || [200, 201, 202, 204, 404, 504];
			invariant(!expected || expected instanceof Array, 'expected is not an array or empty');

			const resp = await fetch(url, options);

			// status code is not expected, dispatch an error
			if (expected.indexOf(resp.status) === -1) {
				error(resp.status === 403
					? t(['api.error.403', "You can't perform this action"])
					: t(['api.error.main', 'An %status% error (%statusText%) occurred on %url%'], resp)
				);
			}
			return resp;
		};
	};
}
